import { ID, Task, Timestamp, UpdateTask, WeekDays } from '@griply/types';
import { getTasksRescheduleUpdates } from '@griply/utils';

export type Options = {
  weekStartsOn: WeekDays;
  today: Timestamp;
};

// Date-only surface: change the deadline/occurrence while keeping each task's
// existing timeslot and reminderTime intact (the shared util preserves any
// field that is not explicitly overridden).
export const buildDateUpdateTasks = (
  tasks: Task[],
  date: Timestamp | undefined,
  currentValue: Timestamp | undefined,
  { weekStartsOn, today }: Options,
): UpdateTask[] =>
  getTasksRescheduleUpdates(
    tasks,
    { startDate: date ?? null },
    {
      today,
      weekStartsOn,
      displayDates: currentValue
        ? new Map<ID, Timestamp>(
            tasks.map(({ id }) => [id, currentValue] as const),
          )
        : undefined,
    },
  );
